import { servicesAdmins } from 'services';
import { TAsyncStatesHandlers } from 'hooks/use-mutation-hook-wrapper';
import { admins as typesAdmin, network } from 'types';
import useQueryHookWrapper from 'hooks/use-query-hook-wrapper';

const useAdminsGet = (
    arg0?: TAsyncStatesHandlers<
        network.TQueryDefWrapper<typesAdmin.TAdmins[]>,
        string
    >,
) => {
    return useQueryHookWrapper<
        network.TQueryDefWrapper<typesAdmin.TAdmins[]>,
        string,
        null
    >({
        queryKey: 'admins',
        queryFn: servicesAdmins.get,
        queryConfig: arg0,
        values: null,
    });
};

export default useAdminsGet;
